'use client'

import {useTranslation} from '../../../hooks/useTranslation'
import {cn} from '../../../lib/utils'
import type {PublicPartnerServiceTerms} from '../../../services/service-terms.service'
import {PUBLIC_SITE_CONTENT_CLASS_NAME, PublicPageHero, PublicSiteShell} from './PublicSiteShell'
import {publicEntryStyles, publicTermsStyles} from './publicEntryStyles'

type PublicPrivacyPolicyPageProps = {
    partnerName: string
    showAboutPage?: boolean
    privacyPolicy: PublicPartnerServiceTerms
}

export function PublicPrivacyPolicyPage({
    partnerName,
    showAboutPage = true,
    privacyPolicy
}: PublicPrivacyPolicyPageProps) {
    const {t} = useTranslation('landing')
    const hasPolicy = privacyPolicy.available && privacyPolicy.html.trim().length > 0

    return (
        <PublicSiteShell
            activePage="privacy"
            partnerName={partnerName}
            showAboutPage={showAboutPage}
        >
            <div className={cn(PUBLIC_SITE_CONTENT_CLASS_NAME, publicEntryStyles.pagePaddingLoose)}>
                <PublicPageHero
                    title={t('publicEntry.privacy.title')}
                />

                <section className="mt-8" aria-labelledby="public-privacy-policy-content">
                    <h2 id="public-privacy-policy-content" className="sr-only">{t('publicEntry.privacy.title')}</h2>
                    {hasPolicy ? (
                        <div className={publicTermsStyles.contentShell}>
                            <article
                                data-testid="public-privacy-policy-html"
                                className={publicTermsStyles.termsHtml}
                                dangerouslySetInnerHTML={{__html: privacyPolicy.html}}
                            />
                        </div>
                    ) : (
                        <div className={publicEntryStyles.panel}>
                            {t('publicEntry.privacy.empty')}
                        </div>
                    )}
                </section>
            </div>
        </PublicSiteShell>
    )
}
